import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Icon, Menu, Dropdown } from 'antd';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
  TemplatePageOverview,
  TemplateImage,
  DropdownDetails,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import Loader from '../../components/Loader';
import CreateMailTemplateModal from '../../components/CreateNewTemplate/CreateMailTemplateModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import LockStatusCheckModal from '../../components/Modals/LockStatusCheckModal';
import { getTemplateStatus } from '../../utils/services/templatesAPI';

// app store context API
import { dayConversion, monthConversion } from '../../utils/javascript';
import { AppStoreContext } from '../../context/appStoreContext';
import { correctBaseUrl } from '../../utils/svgUtils';
import { EMAIL_TEMPLATES_LIST } from './translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['EMAIL_TEMPLATES_LIST'];

const EmailTemplateSection = props => {
  const { mailCategoryList } = props;
  const { t } = useTranslation(NAMESPACES);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const {
    loginVisible,
    templatesList,
    totalTemplates,
    fetchingCategories,
    userDetails,
  } = useContext(AppStoreContext);
  const [lockedBy, setLockedBy] = useState({});
  const history = useHistory();

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedTemplate) &&
      Boolean(selectedTemplate.id) &&
      !Boolean(selectedAction)
    ) {
      history.push(`/emailDesign/${selectedTemplate.id}`);
    }
  }, [loginVisible, selectedTemplate, selectedAction, history]);

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-template'].some(data => data === actionType);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
    setSelectedTemplate(null);
  };

  const redirectToMailTemplate = template => {
    if (template.mailTemplateId) {
      history.push(`/emailDesign/${template.mailTemplateId}`);
    }
  };

  const onCreateSuccess = template => {
    redirectToMailTemplate(template.data);
  };

  const onSuccessMailDeletion = async () => {
    setUpdateModalVisibility(false);
    props.deteteTemplate(true);
  };

  const checkTemplateStatus = async template => {
    const templateStatus = await getTemplateStatus(template.id, 'emailTemplate');
    if (templateStatus?.data) {
      const { locked, lockedBy } = templateStatus.data;
      if (userDetails && locked && lockedBy) {
        const locked = userDetails.id !== lockedBy.userId;
        if (locked) {
          setLockedBy(lockedBy);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
  };

  return (
    <>
      <Container>
        {fetchingCategories ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          <TemplateConatiner>
            <>
              {totalTemplates === 0 ? (
                ''
              ) : (
                <>
                  <TemplateWrapper>
                    {templatesList.map(templateObj => {
                      let mailtemplate = {
                        id: templateObj.mailTemplateId,
                        type: 'mailTemplate',
                      };
                      return (
                        <div className="test" key={templateObj.id}>
                          <TemplatePageOverview
                            key={templateObj.mailTemplateId}
                            title={templateObj.name}
                            onClick={() => redirectToMailTemplate(templateObj)}
                          >
                            <TemplateImage mailTemplate={true}>
                              <div className="image-wrapper">
                                <div className="preview-image-div">
                                  <img
                                    src={
                                      templateObj.thumbNailUrl
                                        ? correctBaseUrl(templateObj.thumbNailUrl)
                                        : PageNotFoundIllustration
                                    }
                                    alt="pageObj-thumbnail"
                                    className={!templateObj.thumbNailUrl ? 'no-thumbnail' : ''}
                                  />
                                </div>
                              </div>
                              <DropdownDetails
                                id={`${templateObj.id}-template`}
                                className="dropdown-menu"
                                onClick={e => e.stopPropagation()}
                              >
                                <Dropdown
                                  overlay={
                                    <Menu>
                                      <Menu.Item
                                        key="0"
                                        onClick={() => redirectToMailTemplate(templateObj)}
                                      >
                                        {t(
                                          EMAIL_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.key,
                                          EMAIL_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.value,
                                        )}
                                      </Menu.Item>
                                      <Menu.Item
                                        key="1"
                                        onClick={() =>
                                          enableModalVisibility(
                                            'delete-mail-template',
                                            mailtemplate,
                                          )
                                        }
                                      >
                                        {t(
                                          EMAIL_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION.key,
                                          EMAIL_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION
                                            .value,
                                        )}
                                      </Menu.Item>
                                    </Menu>
                                  }
                                  trigger={['click']}
                                  getPopupContainer={() =>
                                    document.getElementById(`${templateObj.id}-template`)
                                  }
                                >
                                  <Icon type="more" />
                                </Dropdown>
                              </DropdownDetails>
                            </TemplateImage>
                            <div className="template_name">
                              <div
                                className="name"
                                onClick={() => redirectToMailTemplate(templateObj)}
                              >
                                {templateObj.name}{' '}
                              </div>
                              <div className="categoryName">
                                <div className="box2"></div>
                                {mailCategoryList.length > 0 &&
                                  mailCategoryList.map(category => (
                                    <div key={category.id}>
                                      {templateObj.categoryId === category.categoryId &&
                                        category.categoryName}
                                    </div>
                                  ))}
                              </div>
                              <div className="template_date">
                                <p>
                                  {templateObj.updatedOn
                                    ? dayConversion(templateObj.updatedOn)
                                    : dayConversion(templateObj.createdOn)}
                                </p>
                                <p className="month">
                                  {templateObj.updatedOn
                                    ? monthConversion(templateObj.updatedOn)
                                    : monthConversion(templateObj.createdOn)}
                                </p>
                              </div>
                            </div>
                          </TemplatePageOverview>
                        </div>
                      );
                    })}
                  </TemplateWrapper>
                </>
              )}
            </>
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              (selectedAction === 'create-email-template' ? (
                <CreateMailTemplateModal
                  visible={updateModalVisibility}
                  onCancel={disableModalVisibility}
                  onSucess={onCreateSuccess}
                  categoryType="template"
                />
              ) : (
                ''
              ))}
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              (selectedAction === 'delete-mail-template' ? (
                <DeleteTemplateModal
                  visible={updateModalVisibility}
                  onCancel={disableModalVisibility}
                  targetTemplate={selectedTemplate}
                  categoryType="template"
                  onSucess={onSuccessMailDeletion}
                  isMailTemplate={true}
                />
              ) : (
                ''
              ))}
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              selectedAction === 'template-locked' && (
                <LockStatusCheckModal
                  visible={updateModalVisibility}
                  lockedBy={lockedBy}
                  onCancel={disableModalVisibility}
                />
              )}
            {templatesList.length !== 0 && (
              <>
                {/* {(templatesList.length !== totalTemplates && templatesList.length >= 8) ? */}
                {templatesList.length !== totalTemplates ? (
                  <div className="addMore">
                    <Icon type="loading" />
                    {t(
                      EMAIL_TEMPLATES_LIST.LOADING_MORE.key,
                      EMAIL_TEMPLATES_LIST.LOADING_MORE.value,
                    )}
                  </div>
                ) : (
                  <div className="allData">
                    {t(
                      EMAIL_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.key,
                      EMAIL_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.value,
                    )}
                  </div>
                )}
              </>
            )}
          </TemplateConatiner>
        )}
        {!fetchingCategories && templatesList.length === 0 && (
          <EmptySettingsDetails>
            <div className="empty-illustration">
              <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
            </div>
            <div className="empty-txt" style={{ color: 'black' }}>
              <span>
                {t(
                  EMAIL_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.key,
                  EMAIL_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.value,
                )}
              </span>
              <span
                className="empty-links"
                onClick={() => enableModalVisibility('create-email-template', null)}
              >
                {t(
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.key,
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.value,
                )}
              </span>
              <span>
                {t(
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.key,
                  EMAIL_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.value,
                )}
              </span>
            </div>
          </EmptySettingsDetails>
        )}
      </Container>
    </>
  );
};

export default EmailTemplateSection;
